import { render, staticRenderFns } from "./setDirectAndSpareModal.vue?vue&type=template&id=fda72886&scoped=true&"
import script from "./setDirectAndSpareModal.vue?vue&type=script&lang=js&"
export * from "./setDirectAndSpareModal.vue?vue&type=script&lang=js&"
import style0 from "./setDirectAndSpareModal.vue?vue&type=style&index=0&id=fda72886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda72886",
  null
  
)

component.options.__file = "setDirectAndSpareModal.vue"
export default component.exports